import http from "@services/httpService"
import { L, LNotification } from "@lib/abpUtility"
import { notifyError, notifySuccess } from "@lib/helper"
import { PagedResultDto } from "@services/dto/pagedResultDto"

class BookingReservationService {
  public async createOrUpdate(body: any) {
    const res = await http.post(
      "api/services/app/BookingReservation/CreateOrUpdate",
      body
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }

  public async delete(id: number) {
    const res = await http.delete(
      "api/services/app/BookingReservation/Delete",
      { params: id }
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("DELETE_SUCCESSFULLY")
    )
    return res.data
  }

  public async get(id: number): Promise<any> {
    if (!id) {
      notifyError(L("ERROR"), L("ENTITY_NOT_FOUND"))
    }
    const res = await http.get("api/services/app/BookingReservation/Get", {
      params: { id },
    })
    const { result } = res.data
    return result
  }

  public async getAll(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get("api/services/app/BookingReservation/GetAll", {
      params,
    })
    return res.data.result
  }
  public async getOverview(params: any): Promise<any> {
    const res = await http.get(
      "api/services/app/BookingReservation/GetOverview",
      { params }
    )
    return res.data.result
  }
  public async updateStatus(body: any) {
    const res = await http.put(
      "api/services/app/BookingReservation/UpdateStatus",
      body
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }

  public async submitRequest(body: any): Promise<any> {
    const res = await http.post(
      "api/services/app/BookingReservation/SubmitRequest",
      body
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }

  public async getLatestRequest(bookingReservationId: number): Promise<any> {
    const res = await http.get(
      "api/services/app/BookingReservation/GetLatestRequest",
      { params: { bookingReservationId } }
    )
    return res.data.result
  }

  public async processRefundBooking(body: {
    bookingReservationRequestId: number
    processDate: string
  }): Promise<void> {
    await http.post(
      "api/services/app/BookingReservation/ProcessRefundBooking",
      body
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
  }

  public async processOffsetBooking(body: {
    bookingReservationRequestId: number
    processDate: string
  }): Promise<void> {
    await http.post(
      "api/services/app/BookingReservation/ProcessOffsetBooking",
      body
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
  }
}

export default new BookingReservationService()
